<template>
  <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('createUtilisateur.editCollaborateur', { nomPrenom: libelle }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a class="button is-cancel btn-modal-annuler "
               @click="$router.push({name: 'l.parametrage.collaborateurs' })">
              {{ $t('createUtilisateur.actions.cancel')}}
            </a>
            <a class="button is-addOrEdit " @click="saveUtilisateur()">
              {{ $t('general.button.sauvegarder')}}
            </a>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                            :error="error"
                            :messagesChampsVide="messagesChampsVide"
                            :champsVide="champsVide"
                            :title="'editionClient.problemOccurred'"
                            :withEmplyFields="true"
                            @close="error = $event"/>
    <div class="tab">
      <ul>
        <li @click="activeTab = 'AppInfoUtilisateur'"
            :class="{'is-active': activeTab === 'AppInfoUtilisateur'}">
          {{ $t('createUtilisateur.onglet.collaborateur')}}
        </li>
        <li @click="activeTab = 'AppSocieteAgence'"
            :class="{'is-active': activeTab === 'AppSocieteAgence'}">
          {{ $t('createUtilisateur.onglet.societeAgence')}}
        </li>
        <li @click="activeTab = 'AppRole'"
            :class="{'is-active': activeTab === 'AppRole'}">
          {{ $t('createUtilisateur.onglet.role')}}
        </li>
        <li @click="activeTab = 'ServiceUtilisateur'"
            :class="{'is-active': activeTab === 'ServiceUtilisateur'}">
          {{ $t('createUtilisateur.onglet.service')}}
        </li>
        <li @click="activeTab = 'AppSecteurUtilisateur'"
            v-if="moduleSecteurActive"
            :class="{'is-active': activeTab === 'AppSecteurUtilisateur'}">
          {{ $t('createUtilisateur.onglet.secteur')}}
        </li>
      </ul>
    </div>
    <div>
      <keep-alive>
        <component :is="activeTab" :infoUser="utilisateur"
          :utilisateur="utilisateur" :isAdd="false" :isEdit="true"
          :societesAgence="societesAgence" @editAgenceRattachement="editAgenceRattachement()"/>
      </keep-alive>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppBreadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import inProgress from '@/services/general/inProgress';
import AppInfoUtilisateur from '@/components/parametrage/utilisateur/firstStepInformationsUtilisateur';
import AppSocieteAgence from '@/components/parametrage/utilisateur/secondStepInformationsUtilisateur';
import AppRole from '@/components/parametrage/utilisateur/thirdStepInformationsUtilisateur';
import AppSecteurUtilisateur from '@/components/parametrage/utilisateur/secteurUtilisateur';
import validation from '@/services/parametrage/validation/validationModificationUtilisateur';
import AppSteps from '@/components/general/steps';
import { get, update } from '@/api/utilisateur/index';
import intToGuid from '@/services/general/transformIntToGuid';
import { getAllSocietesAgences } from '@/services/societe/getSocieteAgence';
import { getNewAgenceRattachement } from '@/services/societe/getAgenceRattachement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { SET_USER } from '@/store/modules/user-mutation-type';
import ServiceUtilisateur from '@/components/parametrage/utilisateur/serviceUtilisateur';

const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  components: {
    AppBreadcrumb,
    AppInfoUtilisateur,
    AppSocieteAgence,
    AppSteps,
    AppRole,
    AppSecteurUtilisateur,
    errorMsgComponent,
    ServiceUtilisateur,
  },
  data() {
    return {
      societesAgence: [],
      utilisateur: null,
      activeTab: 'AppInfoUtilisateur',
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      libelle: '',
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('createUtilisateur.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('createUtilisateur.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$i18n.t('createUtilisateur.listeCollaborateur'), route: { name: 'l.parametrage.collaborateurs' }, isActive: false },
        { title: this.$i18n.t('createUtilisateur.editCollaborateur', { nomPrenom: this.libelle }), route: { name: 'm.parametrage.collaborateurs-edit', params: { id: this.$route.params.id } }, isActive: true },
      ];
      return output;
    },
    moduleSecteurActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      updateAttachments: 'update',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    editAgenceRattachement() {
      getNewAgenceRattachement(this.utilisateur.agenceId, this.societesAgence,
        this.utilisateur.agencesId);
    },
    setUserStore(user) {
      return this.$store.commit(`user/${SET_USER}`, user);
    },
    async saveUtilisateur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.utilisateur.roles = [];
        this.utilisateur.objetsRoles.forEach((role) => {
          this.utilisateur.roles.push(role.normalizedName);
        });
        this.utilisateur.servicesId = this.utilisateur.services.map(s => s.id);
        if (this.utilisateur.motPasse && this.utilisateur.motPasse.length > 0
          && this.utilisateur.motPasse !== this.utilisateur.motPasseConf) {
          throw new Error('MOT_PASSE_DIFFERENT');
        }
        if (this.utilisateur.motPasse === '') this.utilisateur.motPasse = null;
        await this.updateAttachments(intToGuid(this.$route.params.id));
        await update(this.utilisateur);
        if (this.moduleSecteurActive && this.user.id === this.utilisateur.id) {
          this.user.secteursId = this.utilisateur.secteursId ?? [];
          this.setUserStore(this.user);
        }
        messageSucces(this.$t('createUtilisateur.editSuccess'));
        this.$router.push({ name: 'c.parametrage.collaborateurs', params: { id: this.utilisateur.id } });
        return loadingComponent.close();
      } catch (e) {
        if ((e.response && e.response.data.error) || e.message) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, e.message, this.champsVide, this.messages,
            this.messagesChampsVide);
          this.error = true;
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Utilisateur' });
      if (this.$route.params.id) {
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        const response = await get(this.$route.params.id);
        await this.setAttachmentElementId({ id: intToGuid(this.$route.params.id) });
        this.utilisateur = response.data.result;
        this.libelle = nomPrenomGetter(cloneDeep(this.utilisateur));
        this.societesAgence = await getAllSocietesAgences(
          this.utilisateur.agenceId, this.utilisateur.agencesId,
        );
        this.setInformationPage(this.$t('pageGeneral.modification', { item: nomPrenomGetter(this.utilisateur) }));
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
    }
  },
};
</script>
